var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgFlask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flask"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.8275 9.5897C12.5151 9.00234 12.3514 8.34491 12.3514 7.67692V5.04583C12.3514 4.68217 12.4933 4.33341 12.7458 4.07626C12.9984 3.81912 13.1402 3.47036 13.1402 3.1067V2.32048C13.1402 1.95937 12.8528 1.66663 12.4981 1.66663H7.01817C6.66353 1.66663 6.37603 1.95937 6.37603 2.32048V3.1067C6.37603 3.47036 6.5179 3.81912 6.77044 4.07626C7.02298 4.33341 7.16486 4.68217 7.16486 5.04583V7.67692C7.16486 8.34491 7.00122 9.00234 6.68877 9.5897M12.8275 9.5897L13.4975 11.25L15.3988 15.9618C15.9682 17.0321 15.2071 18.3333 14.0116 18.3333H5.50468C4.30918 18.3333 3.54806 17.0321 4.11745 15.9618L4.41935 15.2136M12.8275 9.5897H6.68877M6.68877 9.5897L6.0188 11.25L5.17812 13.3333M5.17812 13.3333H6.68877M5.17812 13.3333L4.41935 15.2136M4.41935 15.2136H6.61724",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlask);
export default __webpack_public_path__ + "static/media/flask.a1266c48f2e7627bf67321ba21ffa139.svg";
export { ForwardRef as ReactComponent };